import FormInputAddressSwitch from 'components/FormAddReceiver/components/FormInputAddressSwitch';
import FormInputAddressManuallyValidation from 'components/FormEditReceiver/components/FormInputAddressManuallyValidation';
import ButtonCommon from 'components/common/ButtonCommon';
import { checkFormInputValidation } from 'components/common/func';
import BodySectionHeader from 'components/fx/components/BodySectionHeader';
import {
  DESKTOP_MIN_WIDTH,
  EDIT_RECEIVER_POSTAL_NAME,
  EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS,
  EDIT_RECEIVER_STATE_NAME,
  EDIT_RECEIVER_STREET_NAME,
  EDIT_RECEIVER_SUBURB_NAME,
} from 'constants';
import withUpdateReceiverResidentialAddressInitial from 'features/receiver/HOCs/withUpdateReceiverResidentialAddressInitial';
import withUpdateReceiverResidentialAddressValidationInitial from 'features/receiver/HOCs/withUpdateReceiverResidentialAddressValidationInitial';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useVirtualKeyboard from 'hooks/useVirtualKeyboard';
import { isEmpty, isObject } from 'lodash';
import { Fade } from 'react-bootstrap';
import styled from 'styled-components';

const ResidentialAddress = withUpdateReceiverResidentialAddressInitial(
  withUpdateReceiverResidentialAddressValidationInitial((props) => {
    const {
      countryConfig,
      currentStep,
      setCurrentStep,
      handleOnToggleCancelPopup,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
      portalCodeMaskStr,
      setPortalCodeMaskStr,
      cities,
      addressStreetConfig,
      addressStateConfig,
      addressSuburbConfig,
      addressPostcodeConfig,
      addressManualDisableConfig,
    } = props || {};

    const { t } = useLang();
    const { isDesktop } = useDetectDevice();

    const { setAddReceiverResidentialAddress } = useFormAddReceiverStore();

    const { isEditReceiverEnterAddressManuallySelected } = information;

    const isShowAddAddressManual =
      !addressManualDisableConfig && !isEmpty(cities);
    const isManual =
      isEditReceiverEnterAddressManuallySelected || isEmpty(cities);

    const { ref: inputRef, KeyboardFittingElement } = useVirtualKeyboard();

    const renderAddressManually = () => {
      if (!isShowAddAddressManual) return null;
      return (
        <FormInputAddressSwitch
          information={information}
          setInformation={setInformation}
          setValidation={setValidation}
        />
      );
    };

    const handleNextStep = async () => {
      let newInformation = { ...information };
      let newValidation = { ...validation };

      delete newInformation['isEditReceiverEnterAddressManuallySelected'];
      delete newValidation['isEditReceiverEnterAddressManuallySelected'];

      if (!addressStreetConfig.required) {
        delete newInformation[EDIT_RECEIVER_STREET_NAME];
        delete newValidation[EDIT_RECEIVER_STREET_NAME];
      }

      if (!addressStateConfig.required) {
        delete newInformation[EDIT_RECEIVER_STATE_NAME];
        delete newValidation[EDIT_RECEIVER_STATE_NAME];
      }

      if (!addressSuburbConfig.required) {
        delete newInformation[EDIT_RECEIVER_SUBURB_NAME];
        delete newValidation[EDIT_RECEIVER_SUBURB_NAME];
      }

      if (!addressPostcodeConfig.required) {
        delete newInformation[EDIT_RECEIVER_POSTAL_NAME];
        delete newValidation[EDIT_RECEIVER_POSTAL_NAME];
      }

      console.log(
        `⭐ ResidentialAddress 👉 handleNextStep ➡️ newInformation ↩`,
        newInformation,
      );
      console.log(
        `⭐ ResidentialAddress 👉 handleNextStep ➡️ newValidation ↩`,
        newValidation,
      );
      const isAllowNext =
        Object.values(newInformation).every((value) =>
          isObject(value) ? value?.name : value,
        ) && Object.values(newValidation).every((value) => !value);

      if (isAllowNext) {
        setAddReceiverResidentialAddress({
          ...information,
          isEditReceiverEnterAddressManuallySelected: isManual,
        });
        setCurrentStep(currentStep + 1);
      }

      if (!isAllowNext) {
        if (addressStreetConfig.required) {
          newValidation = checkFormInputValidation(
            information[EDIT_RECEIVER_STREET_NAME],
            EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[0],
            newValidation,
          );
        }

        if (addressStateConfig.required) {
          newValidation = checkFormInputValidation(
            information[EDIT_RECEIVER_STATE_NAME]?.name,
            EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[1],
            newValidation,
          );
        }

        if (addressSuburbConfig.required) {
          newValidation = checkFormInputValidation(
            information[EDIT_RECEIVER_SUBURB_NAME]?.name,
            EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[2],
            newValidation,
          );
        }

        if (addressPostcodeConfig.required) {
          newValidation = checkFormInputValidation(
            information[EDIT_RECEIVER_POSTAL_NAME],
            EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[3],
            newValidation,
          );
        }

        setValidation(newValidation);
      }
    };
    const handleBackStep = () => {
      setAddReceiverResidentialAddress({
        ...information,
        isEditReceiverEnterAddressManuallySelected: isManual,
      });
      setCurrentStep(currentStep - 1);
    };
    const renderActionsButton = () => {
      return (
        <Fade in appear>
          <NextWrap>
            <ButtonCommon
              value={t('button_back')}
              onClick={handleBackStep}
              styles={{
                margin: '0px',
                width: '50%',
              }}
              color="var(--ds-c-blue)"
              background="var(--ds-c-white)"
            />
            <ButtonCommon
              value={t('button_next')}
              color="var(--c-primary)"
              background="var(--bg-primary)"
              isFill={true}
              styles={{
                margin: '0px',
                width: '50%',
              }}
              onClick={handleNextStep}
              isUseKeyDown
            />
          </NextWrap>
        </Fade>
      );
    };

    return (
      <>
        <BodySectionHeader
          titleBodySection={!isDesktop && t('edit_receiver_title')}
          titleSection={t('label_address')}
          onToggleCancelPopup={handleOnToggleCancelPopup}
          isDisabled={false}
        />
        <ResidentialAddressStyled>
          {EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS.map((field) => (
            <FormInputAddressManuallyValidation
              ref={inputRef}
              key={field.name}
              field={field}
              countryConfig={countryConfig}
              cities={cities}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              portalCodeMaskStr={portalCodeMaskStr}
              setPortalCodeMaskStr={setPortalCodeMaskStr}
            />
          ))}
          {renderAddressManually()}
          {renderActionsButton()}
        </ResidentialAddressStyled>
        <KeyboardFittingElement />
      </>
    );
  }),
);

const ResidentialAddressStyled = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: -8px;
  padding-inline: 0px;
  padding-bottom: 140px;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 437px;
    margin-top: 0px;
    padding-inline: 0px;
    padding-bottom: unset;
  }
`;

const NextWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 77px;
  width: 100%;
  margin-inline: -16px;
  padding-inline: 16px;
  background: var(--ds-c-white);
  z-index: 1;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #eef2f5;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;

    position: unset;
    margin-top: 40px;
    margin-bottom: 24px;
    margin-inline: unset;
    padding-inline: unset;
    width: 437px;
    height: 44px;
    border-top: unset;
  }
`;

export default ResidentialAddress;
